<script setup lang="ts">
import Modal from '~/components/modals/Modal.vue';
import { useProductStore } from '~/store/product/productStore';
import { MODAL_SIZE_GUIDE } from '~/store/modalStore';

const props = defineProps<{
  isModalVisible: boolean
  closeModal: () => void
}>()

const {
  isModalVisible,
  closeModal,
} = toRefs(props)

const productStore = useProductStore();
const {
  product,
} = storeToRefs(productStore);
</script>

<template>
  <Modal
:id="MODAL_SIZE_GUIDE"
         :is-visible="isModalVisible"
         :title="$t('www.product.sizeguide.brand', {'brandName': product.brand.name})"
         @close="closeModal">
    <div id="modal-size-guide">
      <div id="size-guide-container">
        <picture v-if="product.sizeGuide?.imageUrl">
          <img loading="lazy" :alt="`Guide de taille - ${product.brand.name }`" :src="product.sizeGuide?.imageUrl">
        </picture >
        <table v-else-if="product.sizeGuide?.rows && product.sizeGuide?.rows.length > 0" class="size-guide-content">
          <thead class="table-header">
          <th
              v-for="(col, index) in product.sizeGuide?.rows[0]"
              :key="index">
            {{ col }}
          </th>
          </thead>
          <tbody>
          <tr
              v-for="(line, index) in product.sizeGuide?.rows.slice(1, product.sizeGuide?.rows.length)"
              :key="index"
              class="line">
            <td
                v-for="(col, colindex) in line"
                :key="colindex">
              {{ col != '' ? col : 'NC' }}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </Modal>
</template>
